import React from 'react';

import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import * as S from './styles';
import { IFile } from '../../pages/Configuracoes/TabBar/tabs/Layout/Bannerv2';
import { useToast } from '../../hooks/toast';
import BannerRow from '../BannerRow';
import APIError from '../../errors/APIError';

interface IFileList {
  files: IFile[];
  onDelete: (id: string) => void;
  handleBannerEnabled: (id: string) => void;
  processUpload: (uploadedFile: IFile) => void;
  setUploadedFiles: React.Dispatch<React.SetStateAction<IFile[]>>;
  onSortProducts(files: IFile[]): void;
  onSelectFile: (file: any, id: string) => void
}

const FileList: React.FC<IFileList> = ({
  files,
  onDelete,
  handleBannerEnabled,
  onSortProducts,
  processUpload,
  onSelectFile,
  setUploadedFiles,
}) => {
  const { addToast } = useToast();

  const handleOnDragEnd = async (dropResult: DropResult): Promise<void> => {
    const initialBanners = files;

    try {
      const { destination, source } = dropResult;

      if (
        typeof destination?.index === 'number' &&
        source.index !== destination.index &&
        files
      ) {
        let sortedProducts = Array.from(files);
        const [removedProduct] = sortedProducts.splice(source.index, 1);

        sortedProducts.splice(destination.index, 0, removedProduct);

        sortedProducts = sortedProducts.map((product, productIndex) => ({
          ...product,
          order: productIndex + 1,
        }));

        onSortProducts(sortedProducts);
      }
    } catch (error) {
      onSortProducts(initialBanners);

      if (error instanceof APIError) {
        addToast({
          title: error.message,
          type: 'error',
        });

        return;
      }

      addToast({
        title: 'Ocorreu um erro durante a operação',
        type: 'error',
      });
    }
  };

  return (
    <S.Container>
      <S.CustomTable>
        <S.TableHeader>
          <S.TableCell>
            <th>Imagem</th>
          </S.TableCell>
          <S.TableCell>
            <th>Produto relacionado</th>
          </S.TableCell>
          <S.TableCell>
            <th style={{ justifyContent: 'center', display: 'flex' }}>
              Condição
            </th>
          </S.TableCell>
          <S.TableCell>
            <th style={{ justifyContent: 'center', display: 'flex' }}>
              Status
            </th>
          </S.TableCell>
          <S.TableCell />
        </S.TableHeader>
        <S.TableBody>
          {files && (
            <DragDropContext
              onDragEnd={(dragResult) => {
                handleOnDragEnd(dragResult);
              }}
            >
              <Droppable droppableId="droppableProducts">
                {(droppableProvided) => (
                  <tr
                    ref={droppableProvided.innerRef}
                    {...droppableProvided.droppableProps}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    {files
                      .sort((a, b) => (a?.order ?? 1) - (b?.order ?? 1))
                      .map((file, productIndex) => (
                        <Draggable
                          key={file.id}
                          draggableId={String(file.id)}
                          index={productIndex}
                        >
                          {(draggableProvided) => (
                            <td
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                            >
                              <BannerRow
                                file={file}
                                onSelectFile={onSelectFile}
                                onDelete={() => onDelete(file.id)}
                                onChangePauseSale={() =>
                                  handleBannerEnabled(file.id)
                                }
                                dragHandleProps={
                                  draggableProvided.dragHandleProps
                                }
                                processUpload={processUpload}
                                setUploadedFiles={setUploadedFiles}
                              />
                            </td>
                          )}
                        </Draggable>
                      ))}
                      {droppableProvided.placeholder}
                  </tr>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </S.TableBody>
      </S.CustomTable>
    </S.Container>
  );
};

export default FileList;
